import { GlobalBookingTripDates } from '@fcom/common';
import { TripType } from '@fcom/core/constants';
import { BookingLocationCodes } from '@fcom/common/interfaces/booking';

export enum StatusBarMode {
  HEADER = 'HEADER',
  INLINE = 'INLINE',
  BLOCK = 'BLOCK',
}

export interface StatusBarComponentProps {
  tripType: TripType;
  locations: BookingLocationCodes[];
  paxAmount: number;
  dates: GlobalBookingTripDates;
  mode?: StatusBarMode;
}
